module.exports = __webpack_public_path__ + "assets/parrot_sub.6d1e25a2.svg";